var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
import * as React from "react";
import { Ad, AdUnit } from "../../shared/components/ad";
import Template from "../../shared/components/template";
import Breadcrumbs from "../../shared/patterns/breadcrumbs";
import _ from "../../shared/utils/lodash";
import Booking from "./patterns/booking";
import Description from "./patterns/description";
import Header from "./patterns/header";
import Hero from "./patterns/hero";
import Info from "./patterns/info";
import * as styles from "./styles/pois.css";
import TemplatePoiDetail from "./templates/detail";
import { createAdTargeting } from "./utils/createAdTargeting";
import { getPartnerActivityPricing } from "./utils/getPartnerActivityPricing";
import { getPartnerActivityType } from "./utils/getPartnerActivityType";
import heroImageSizes from "./utils/heroImageSizes";
import { partnerActivityProviders } from "./utils/partnerActivityProviders";
import { analytics, DataLayerInitializationData, DestinationSubNavs, } from "@lonelyplanet/lp-analytics";
import Tags from "./patterns/tags";
var PagePartnerActivity = /** @class */ (function (_super) {
    __extends(PagePartnerActivity, _super);
    function PagePartnerActivity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.provider = {
            gadventures: "G Adventures",
            viator: "Viator",
        };
        _this.hasInclusions = _this.props.poi.inclusions &&
            _this.props.poi.inclusions.length > 0;
        _this.hasExclusions = _this.props.poi.exclusions &&
            _this.props.poi.exclusions.length > 0;
        _this.hasHighlights = _this.props.poi.highlights &&
            _this.props.poi.highlights.length > 0;
        _this.showActivityFeatures = _this.hasInclusions || _this.hasExclusions || _this.hasHighlights;
        _this.hasMedia = _this.props.poi.media &&
            _this.props.poi.media.images &&
            _this.props.poi.media.images.length > 0;
        _this.hasImages = _this.props.poi.images &&
            _this.props.poi.images.length;
        _this.hasMainImageAttributions = _this.hasImages &&
            Array.isArray(_this.props.poi.images[0].attribution) &&
            _this.props.poi.images[0].attribution.length > 0;
        _this.hasDescription = _this.props.poi.descriptions && (_this.props.poi.descriptions.shortDescription ||
            _this.props.poi.descriptions.longDescription);
        _this.hasEssentialInfo = _this.props.poi.duration ||
            _this.props.poi.departureInfo ||
            _this.props.poi.returnInfo;
        _this.hasItinerary = _this.props.poi.itinerary &&
            _this.props.poi.itinerary.length;
        _this.place = _this.props.places.find(function (p) { return _this.props.match.params.placeId === p.id; });
        return _this;
    }
    Object.defineProperty(PagePartnerActivity.prototype, "providerAttributions", {
        get: function () {
            /**
             * To be used in lieu of actual data from the API when we're using poi.media.images
             * instead of poi.images; the former do not have attribution data, so we substitute in the name of the provider.
             */
            return [
                {
                    name: null,
                    organization: this.provider[this.props.poi.provider],
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    PagePartnerActivity.prototype.render = function () {
        var _a;
        var _b = this.props, breadcrumbs = _b.breadcrumbs, tags = _b.tags, meta = _b.meta, poi = _b.poi, dataLayer = _b.dataLayer, bookmarked = _b.bookmarked, onClickBookmark = _b.onClickBookmark, lpCurrency = _b.lpCurrency;
        var subtype = getPartnerActivityType(poi.duration);
        var activityRating = poi.rating && _.round(parseFloat(poi.rating), 1) + " out of 5";
        var isTour = subtype === "tours";
        var location = isTour ? poi.departureInfo + " to " + poi.returnInfo : this.place.name;
        var _c = getPartnerActivityPricing(lpCurrency, poi.prices), regularPrice = _c.regularPrice, discountedPrice = _c.discountedPrice;
        var poiType = poi.activityType;
        var adTargeting = createAdTargeting(Object.assign({}, dataLayer, { poiType: poiType }));
        return (React.createElement(React.Fragment, null,
            React.createElement(Helmet, null,
                this.hasMedia && [
                    React.createElement("meta", { property: "og:image", content: poi.media.images[0] || "" }),
                    React.createElement("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: poi.media.images[0] || "" }),
                ],
                !this.hasMedia && this.hasImages && [
                    React.createElement("meta", { property: "og:image", content: poi.images[0].url || "" }),
                    React.createElement("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: poi.images[0].url || "" }),
                ],
                !this.hasMedia && !this.hasImages && [
                    React.createElement("meta", { property: "og:image", content: "" }),
                    React.createElement("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: "" }),
                ],
                React.createElement("meta", { className: "swiftype", name: "op-parent-id", "data-type": "string", content: this.place.id }),
                React.createElement("meta", { className: "swiftype", name: "op-parent-name", "data-type": "string", content: this.place.name }),
                React.createElement("meta", { className: "swiftype", name: "op-subtype", "data-type": "string", content: subtype }),
                React.createElement("meta", { className: "swiftype", name: "op-type-partner-activity", "data-type": "integer", content: "100" }),
                React.createElement("meta", { className: "swiftype", name: "top-choice", "data-type": "integer", content: "0" }),
                React.createElement("meta", { className: "swiftype", name: "grade", "data-type": "float", content: "0" }),
                tags.map(function (tag) { return ([
                    React.createElement("meta", { className: "swiftype", name: "tag", "data-type": "string", content: tag.label }),
                    React.createElement("meta", { className: "swiftype", name: tag.tag_type + "-id", "data-type": "enum", content: tag.tag_id })
                ]); })),
            React.createElement(DataLayer, { data: {
                    cd26_PartnerOfferingDetails: poi.name,
                    cd27_PartnerOfferingKind: poi.activityType,
                    cd28_PartnerName: partnerActivityProviders[poi.provider].name,
                    kind: poi.activityType === "tour" ? "tours" : "activities",
                    poiType: poiType,
                } }),
            React.createElement(DataLayerInitializationData, { data: (_a = {},
                    _a[analytics.contentCity] = poi.containingCityName,
                    _a[analytics.contentContinent] = poi.containingContinentName,
                    _a[analytics.contentCountry] = poi.containingCountryName,
                    _a[analytics.contentNeighborhood] = poi.containingNeighborhoodName,
                    _a[analytics.contentRegion] = poi.containingRegionNames && poi.containingRegionNames.join(", "),
                    _a[analytics.destinationSubNav] = DestinationSubNavs.activities,
                    _a[analytics.poiName] = poi.name,
                    _a[analytics.poiType] = poi.type,
                    _a), indexForEntirePayload: 1 }),
            React.createElement(TemplatePoiDetail, null,
                React.createElement(Template.Position, { area: "breadcrumbs" },
                    React.createElement(Breadcrumbs, { className: styles.breadcrumbs, links: breadcrumbs })),
                React.createElement(Template.Position, { area: "header" },
                    React.createElement(Header, { title: poi.name, type: poi.canonicalCategory, location: location, bookmarked: bookmarked, onClickBookmark: onClickBookmark, isTour: isTour })),
                this.hasMedia &&
                    React.createElement(Template.Position, { area: "hero" },
                        poi.media.images.length === 1 &&
                            React.createElement(Hero.Photo, { src: poi.media.images[0], alt: "", sizes: heroImageSizes.single.main }),
                        poi.media.images.length > 1 &&
                            React.createElement(Hero.Gallery, { images: poi.media.images })),
                !this.hasMedia && this.hasImages &&
                    React.createElement(Template.Position, { area: "hero" },
                        poi.images.length === 1 &&
                            React.createElement(Hero.Photo, { src: poi.images[0].url, alt: "", sizes: heroImageSizes.single.main }),
                        poi.images.length > 1 &&
                            React.createElement(Hero.Gallery, { images: poi.images.map(function (image) { return image.url; }) })),
                this.hasMedia &&
                    React.createElement(Template.Position, { area: "heroAttribution" },
                        React.createElement(Hero.Attribution, { attributions: this.providerAttributions })),
                !this.hasMedia && this.hasMainImageAttributions &&
                    React.createElement(Template.Position, { area: "heroAttribution" },
                        React.createElement(Hero.Attribution, { attributions: poi.images[0].attribution })),
                this.hasDescription &&
                    React.createElement(Template.Position, { area: "descriptionPartner" },
                        React.createElement(Description, null,
                            React.createElement(Description.Heading, null,
                                "Tour description provided by ",
                                this.provider[poi.provider]),
                            poi.descriptions.shortDescription &&
                                React.createElement(Description.Text, null,
                                    React.createElement("div", { dangerouslySetInnerHTML: { __html: poi.descriptions.shortDescription } })),
                            poi.descriptions.longDescription &&
                                React.createElement(Description.Text, null,
                                    React.createElement("div", { dangerouslySetInnerHTML: { __html: poi.descriptions.longDescription } })))),
                React.createElement(Template.Position, { area: "callToActionMobile" },
                    React.createElement(Booking.Activity, { activityName: poi.name, activityType: poi.activityType, price: regularPrice, discountedPrice: discountedPrice, url: poi.booking, provider: poi.provider, rating: activityRating })),
                React.createElement(Template.Position, { area: "callToActionAside" },
                    React.createElement(Booking.Activity, { activityName: poi.name, activityType: poi.activityType, price: regularPrice, discountedPrice: discountedPrice, url: poi.booking, provider: poi.provider, rating: activityRating })),
                this.hasEssentialInfo &&
                    React.createElement(Template.Position, { area: "infoEssential" },
                        React.createElement(Info, null,
                            React.createElement(Info.Heading, null, "More info"),
                            poi.duration &&
                                React.createElement(Info.Item, { label: "Duration" },
                                    poi.duration.duration,
                                    " ",
                                    poi.duration.unit),
                            poi.departureInfo &&
                                React.createElement(Info.Item, { label: "Departs" }, poi.departureInfo),
                            poi.returnInfo &&
                                React.createElement(Info.Item, { label: "Returns" }, poi.returnInfo))),
                tags && tags.length > 0 &&
                    React.createElement(Template.Position, { area: "activityTags" },
                        React.createElement(Tags, { data: tags })),
                React.createElement(Template.Position, { area: "adRail" },
                    React.createElement(Ad.Primary, null,
                        React.createElement(AdUnit.SideRail, { adUnit: "poisRightRail", targeting: adTargeting }))),
                this.showActivityFeatures &&
                    React.createElement(Template.Position, { area: "activityFeatures" },
                        this.hasInclusions &&
                            React.createElement(Description, null,
                                React.createElement(Description.Heading, null, "What\u2019s included"),
                                React.createElement(Description.Text, null,
                                    React.createElement("ul", null, poi.inclusions.map(function (item) { return (React.createElement("li", { key: item }, item)); })))),
                        this.hasExclusions &&
                            React.createElement(Description, null,
                                React.createElement(Description.Heading, null, "What\u2019s not included"),
                                React.createElement(Description.Text, null,
                                    React.createElement("ul", null, poi.exclusions.map(function (item) { return (React.createElement("li", { key: item }, item)); })))),
                        this.hasHighlights &&
                            React.createElement(Description, null,
                                React.createElement(Description.Heading, null, "Highlights"),
                                React.createElement(Description.Text, null,
                                    React.createElement("ul", null, poi.highlights.map(function (item) { return (React.createElement("li", { key: item }, item)); }))))),
                this.hasItinerary &&
                    React.createElement(Template.Position, { area: "tourItinerary" },
                        React.createElement(Description, null,
                            React.createElement(Description.Heading, null, "Itinerary"),
                            poi.itinerary.map(function (item) { return (React.createElement(Description.Text, null,
                                React.createElement("strong", null, item.title),
                                " ",
                                item.description)); }))),
                React.createElement(Template.Position, { area: "adSuperzone" },
                    React.createElement(Ad.Bounded, null,
                        React.createElement(AdUnit.Superzone, { adUnit: "poisSuperzone", targeting: adTargeting }))))));
    };
    return PagePartnerActivity;
}(React.Component));
export default PagePartnerActivity;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/partnerActivity.tsx
// module id = HZ7U
// module chunks = 2